module.exports = __webpack_public_path__ + "static/10-8b357ee09861406f8d374b951f51973e.jpg";